module.exports = __webpack_public_path__ + "static/media/magnifier.4b7443a2.svg";